import styled, { css } from 'styled-components';
import { boxShadow } from '../../../commonStyles/boxStyles';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';

const transformTransition = 'transform 0.3s ease-out';

export const HeadingWrapper = styled.div`
  display: flex;
`;

export const IconWrapper = styled.span`
  position: relative;
  color: ${colors.cardIcon};
  margin-right: ${spacing(2)};
  flex: 0 0 ${spacing(4)};
`;

export const ChevronWrapper = styled.span`
  margin-left: auto;
  display: inline-block;
  color: ${colors.cardIcon};

  padding: 0 0 0 ${spacing(2)};

  transition: ${transformTransition};
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Heading = styled.h3`
  ${fonts.headingSmall}
  margin: 0;
`;

export const Subheading = styled.p`
  ${fonts.paragraphSmall}
  margin: 0;
`;

export const Body = styled.p`
  ${fonts.paragraph}
  margin: ${spacing(2)} 0 0 0;
`;

export type ActionCardContainerProps = {
  disabled?: boolean;
};

const borderPx = 1;

const nonDisabledLinkStyles = css<ActionCardContainerProps>`
  &:link, /* to override IE's automatic blue link styles */
  &:visited {
    color: inherit;
  }

  &:hover,
  &:focus-visible {
    box-shadow: ${boxShadow};
    transform: translateY(-${spacing(1)});
  }

  &:focus-visible {
    border-color: ${colors.core02};
  }

  &:active {
    transform: none;
    border-color: ${colors.core02};
    box-shadow: inset -2px 2px 4px 2px rgba(0, 0, 0, 0.12);
  }

  &:hover,
  &:focus-visible,
  &:active {
    ${Heading} {
      color: ${colors.core01};
    }

    ${ChevronWrapper} {
      transform: translateX(${spacing(1)});
    }
  }
`;

const disabledLinkStyles = css`
  cursor: not-allowed;
  border-color: ${colors.neutral01};
  opacity: 0.4;

  ${IconWrapper},
  ${ChevronWrapper} {
    color: ${colors.neutral01};
  }
`;

export const ActionCardContainer = styled.a<ActionCardContainerProps>`
  /* Spacing */
  display: flex;
  flex-flow: column nowrap;

  margin: ${spacing(1)} 0;

  padding: ${spacingWithBorder(4, borderPx)};
  border: ${borderPx}px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(2)} 0;
  `}

  /* Link styling */
  text-decoration: none;
  outline: none;

  ${({ disabled }) => !disabled && nonDisabledLinkStyles}
  ${({ disabled }) => disabled && disabledLinkStyles}

  transition: ${transformTransition};
`;
